import React, {Component} from 'react'
import {AvInput} from 'availity-reactstrap-validation'
import {withSubscription} from '../HOC/subscription'

export default (schema, dataStructure, uniqueKey, displayFields, variables = []) => {

    class Select extends Component{
        render(){
            const {data, value, defaultLabel} = this.props

            return (
                <AvInput type="select" {...this.props} onChange={(event) => {
                    this.props.onChange(event.target.value)
                    if(this.props.onChangeObj) this.props.onChangeObj(data[schema].find(obj => obj[uniqueKey] == event.target.value))
                }} value={value || ''}>
                    <option value="">{(defaultLabel) ? defaultLabel : '---Please Select---'}</option>
                    {(data && data[schema]) && data[schema].map((value, index) => <option key={index} value={value[uniqueKey]}>
                        {displayFields.map(field => value[field]).join(' ')}
                        </option>)}
                </AvInput>
            )
        }
    }

    return withSubscription(Select, schema, dataStructure, uniqueKey, variables)
}
